import React, { useState } from 'react';
import './Navigation.css';

const Navigation: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Handle navigation link click with smooth scrolling
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    e.preventDefault(); // Prevent default anchor behavior
    const targetElement = document.getElementById(sectionId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    toggleMenu(); // Close the menu
  };

  return (
    <>
      <button className="nav-toggle" onClick={toggleMenu}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="var(--secondary-text-color)"
          strokeWidth="2"
        >
          <line x1="3" y1="6" x2="21" y2="6" />
          <line x1="3" y1="12" x2="21" y2="12" />
          <line x1="3" y1="18" x2="21" y2="18" />
        </svg>
      </button>

      {isMenuOpen && (
        <nav className="nav-menu">
          <ul>
            <li>
              <a href="#about" onClick={(e) => handleNavClick(e, 'about')}>
                About
              </a>
            </li>
            <li>
              <a href="#services" onClick={(e) => handleNavClick(e, 'services')}>
                Services
              </a>
            </li>
            <li>
              <a href="#reviews" onClick={(e) => handleNavClick(e, 'reviews')}>
                Reviews
              </a>
            </li>
            <li>
              <a href="#gallery" onClick={(e) => handleNavClick(e, 'gallery')}>
                Gallery
              </a>
            </li>
            <li>
              <a href="#contact" onClick={(e) => handleNavClick(e, 'contact')}>
                Contact
              </a>
            </li>
          </ul>
        </nav>
      )}
    </>
  );
};

export default Navigation;